import * as React from 'react';
import Namer from '../Generic/Namer';

export default Namer('clients', (client) => {
    if (client) {
        return <div> {client.name}</div>;
    } else if (client === 'All Clients') {
        return <div>All Clients</div>;
    } else {
        return <div>No Specific Client Defined </div>;
    }
});


// WEBPACK FOOTER //
// ./src/container/Client/ClientName.tsx